import ipaddr from "ipaddr.js";

/**
 * カレントネットワークアドレスではないことを確認
 * @see {@link https://en.wikipedia.org/wiki/IPv4}
 *
 * チェック内容:
 *    サブネット無しのIPの場合 → カレントネットワークアドレス（0.0.0.0/8）ではないことを確認
 *    サブネット付きのIPの場合 → カレントネットワークアドレス（0.0.0.0/8）以外のアドレスがないことを確認
 */
export default {
  validate: function (value: string | null | undefined): boolean {
    if (!value) return true;

    let ipV4: ipaddr.IPv4 | [ipaddr.IPv4, number];
    try {
      if (value.indexOf("/") !== -1) {
        ipV4 = ipaddr.IPv4.parseCIDR(value);
      } else {
        ipV4 = ipaddr.IPv4.parse(value);
      }
    } catch (e) {
      return true;
    }
    // サブネット付きのIPの場合
    if (Array.isArray(ipV4)) {
      // カレントネットワークアドレス以外のアドレスがないことを確認
      return !(
        ipaddr.IPv4.networkAddressFromCIDR(value).range() === "unspecified" &&
        ipaddr.IPv4.broadcastAddressFromCIDR(value).range() === "unspecified"
      );
    } else {
      // サブネット無しのIPの場合 → カレントネットワークアドレスではないことを確認
      return ipV4.range() !== "unspecified";
    }
  },
};
